var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-status" }, [
    _vm.refundStatus > 0
      ? _c(
          "div",
          [
            _vm.refundStatus == 1
              ? _c(
                  "el-tag",
                  { attrs: { type: "warning", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(_vm.refundStatusName))]
                )
              : _vm._e(),
            _vm.refundStatus == 2
              ? _c(
                  "el-tag",
                  { attrs: { type: "success", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(_vm.refundStatusName))]
                )
              : _vm._e(),
            _vm.refundStatus == 3
              ? _c(
                  "el-tag",
                  { attrs: { type: "warning", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(_vm.refundStatusName))]
                )
              : _vm._e()
          ],
          1
        )
      : _c(
          "div",
          [
            _vm.orderStatus == 0
              ? _c(
                  "el-tag",
                  { attrs: { type: "info", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(_vm.orderStatusName))]
                )
              : _vm._e(),
            _vm.orderStatus == 1
              ? _c(
                  "el-tag",
                  { attrs: { type: "success", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(_vm.orderStatusName))]
                )
              : _vm._e(),
            _vm.orderStatus == 2
              ? _c(
                  "el-tag",
                  { attrs: { type: "info", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(_vm.orderStatusName))]
                )
              : _vm._e(),
            _vm.orderStatus == 99
              ? _c(
                  "el-tag",
                  { attrs: { type: "dark", effect: "plain", size: "mini" } },
                  [_vm._v(_vm._s(_vm.orderStatusName))]
                )
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }